/**
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import { IFair } from '@umati/dashboard-types';
import URLs from '../utilities/URLs';

const SetFullFairImageURLs = (fair: IFair, staticBucketReachable: boolean) => {
  fair.ImageFile = URLs.getFullFairLogoUrl(fair.ImageFile || '', staticBucketReachable);
  return fair;
};

const arrayToObject = (arr: IFair[], key1: keyof IFair, staticBucketReachable: boolean) => {
  return Object.assign(
    {},
    ...arr.map((item) => {
      return { [item[key1]! as string]: SetFullFairImageURLs(item, staticBucketReachable) };
    }),
  );
};

export class FairHandling {
  static deserializeFairsFromBackendRequest(data: IFair[], staticBucketReachable: boolean): { [key: string]: IFair } {
    return arrayToObject(data, 'Tag', staticBucketReachable);
  }
}
